import React from 'react';
import logo from '../logo.svg';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useLanguage } from '../context/LanguageContext';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';

function Header() {
    const { theme, toggleTheme } = useTheme();
    const { currentLanguage, switchLanguage } = useLanguage();
    const { t } = useTranslation();

    return (        <nav 
            className={`navbar navbar-expand-lg mb-4 ${theme === 'dark' ? 'navbar-dark bg-dark' : 'navbar-light bg-light'}`}
            role="navigation"
            aria-label="Main navigation"
        >
            <div className="container-fluid">
                <Link 
                    className="navbar-brand d-flex align-items-center" 
                    to="/"
                    aria-label="DMV Quiz Home"
                >
                    <img src={logo} alt="DMV Quiz Logo" width="40" height="40" className="d-inline-block align-top me-2" />
                    <span aria-hidden="true">DMV Quiz</span>
                </Link>                <div className="d-flex gap-2 align-items-center" role="group" aria-label="Navigation and settings">
                    <select 
                        className="form-select ms-2" 
                        style={{ width: 'auto' }} 
                        aria-label="Select language"
                        value={currentLanguage}
                        onChange={(e) => switchLanguage(e.target.value)}
                    >
                        <option value="en" aria-label="English">🇺🇸 EN</option>
                        <option value="es" aria-label="Spanish">🇪🇸 ES</option>
                        <option value="pt" aria-label="Portuguese">🇧🇷 PT</option>
                    </select>
                    <Button
                        variant="outline-secondary"
                        onClick={toggleTheme}
                        className="ms-2"
                        aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
                        aria-pressed={theme === 'dark'}
                    >
                        <span aria-hidden="true">{theme === 'light' ? '🌙' : '☀️'}</span>
                    </Button>
                </div>
            </div>
        </nav>
    );
}

export default Header;
